// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__+KoEs","tab":"styles_tab__fSX6G","tab__selected":"styles_tab__selected__rVq-k"};